//src/app/features/questionnaires/components/WizardFooter/components/MobileSkeleton.tsx
import { ComponentType } from 'react';

interface MobileSkeletonProps {
  ProceedBtn: ComponentType;
  CancelBtn: ComponentType;
  PreviousBtn: ComponentType;
}

const MobileSkeleton = ({
  ProceedBtn,
  CancelBtn,
  PreviousBtn,
}: MobileSkeletonProps) => {
  return (
    <div className="fixed left-0 right-0 bottom-0 border-t border-gray-800 py-5 px-4 grid grid-rows-2 grid-cols-2 bg-white gap-3">
      <div className="col-span-2">{<ProceedBtn />}</div>
      <div className="">{<PreviousBtn />}</div>
      <div className="">{<CancelBtn />}</div>
    </div>
  );
};

export default MobileSkeleton;
